/**
 * Preferred column ordering for Excel export, keyed by worksheet name (group).
 * Only headers present in the exported data are used; anything not listed falls
 * back to the natural order after these preferences.
 */
const EXCEL_COLUMN_ORDER = {
  // Example: for all transformer worksheets ensure Nombre first, followed by key electrical data.
  Transformadores: ['Nombre', 'Alias', 'Fabricante', 'Modelo', 'Capacidad (kVA)'],
  'Fuentes de energía': ['Nombre', 'Tipo', 'Fabricante', 'Modelo'],
  Cargas: ['Nombre', 'Tipo de carga', 'Capacidad', 'Fabricante'],
  'Electrónica de potencia': ['Nombre', 'Tipo', 'Fabricante', 'Modelo'],
  'Protección contra sobrecorriente': ['Nombre', 'Tipo', 'Corriente Nominal', 'Fabricante'],
  'Bancos y dispositivos de compensación': ['Nombre', 'Tipo', 'Capacidad (kVAR)'],
  'Equipos de distribución': ['Nombre', 'Tipo', 'Calibre', 'Fabricante'],
  Medición: ['Nombre', 'Tipo', 'Fabricante', 'Modelo'],
  dashboard: ['Nombre', 'Familia'],
};

const DEFAULT_COLUMN_PREFS = ['Nombre'];

export const getOrderedHeaders = (headers, groupName) => {
  const headerSet = new Set(headers);
  const ordered = [];
  const pushIfAvailable = (header) => {
    if (headerSet.has(header) && !ordered.includes(header)) {
      ordered.push(header);
    }
  };

  const preferred = EXCEL_COLUMN_ORDER[groupName] || [];

  [...DEFAULT_COLUMN_PREFS, ...preferred].forEach(pushIfAvailable);
  headers.forEach(pushIfAvailable);

  return ordered;
};

export default EXCEL_COLUMN_ORDER;
